// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.navigation-container[data-v-7c7859e6] {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 300px;\n  color: #001978;\n  font-size: 14px;\n  z-index: 99998;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
